const Backbone = require('lib/backbone')
const _ = require('lib/underscore')
const RelatedModel = require('module/user/related_model')
const log = require('log').create('saved image')  

const SavedImage = RelatedModel.extend({

    defaults: {
        highlight: {},
    },

    relations: [
        {
            type: Backbone.One,
            key: 'highlight',
            relatedModel: RelatedModel.extend({ id: 'highlight' }),
        },
    ],

    initialize() {
        const timestamp = this.get('timestamp') || _.now()
        this.set('timestamp', timestamp)
    },

    setAutoHighlight() {
        const highlight = this.get('highlight')
        if (! this.hasHighlight()) {
            const img = this.pick('width', 'height')
            if (! _.isNumber(img.width)) return
            if (! _.isNumber(img.height)) return

            const smallDim = Math.min(img.height, img.width)
            const w = Math.round(smallDim / 2)
            const h = w
            const x = (img.width - w) / 2
            const y = (img.height - h) / 2
            highlight.set({ x, y, w, h })
        }
    },

    hasDims() {
        // checking both dims just to be safe
        return this.get('width') && this.get('height')
    },

    hasHighlight() {
        // checking x and y should suffice
        return _.isNumber(this.get('highlight.x') && this.get('highlight.y'))
    },

    getThumbCrop() {
        // deprecated in favor of getRatioThumbCrop
        // method returns the right 3:2 crop based on highlight

        // assumes image has dims and a highlight
        if (! this.hasDims() || ! this.hasHighlight()) return

        // cache dims
        const img = {
            w: this.get('width'),
            h: this.get('height'),
        }

        const crop = { x: 0, w: 0, y: 0, h: 0 }

        const ratio = img.h / img.w
        log('thumb ratio', ratio)

        if (ratio > 0.6666) {
            // portrait, square, square-ish images
            crop.w = img.w
            crop.h = Math.floor(img.w * 0.6667) // 3:2
            // get center of highlight from top (y + (h / 2))
            const top = this.get('highlight.y') + (this.get('highlight.h') / 2)
            // calculate strict y (t - (h / 2))
            crop.y = top - (crop.h / 2)
            // adjust for image edge
            crop.y = Math.floor(Math.max(0, Math.min(crop.y, img.h - crop.h)))
        } else {
            crop.h = img.h
            crop.w = Math.floor(img.h * 1.5) // 3:2
            // get center of highlight from left (x + (w / 2))
            const left = this.get('highlight.x') + (this.get('highlight.w') / 2)
            // calculate strict x (l - (w / 2))
            crop.x = left - (crop.w / 2)
            log('crop x', left, crop.x)
            // adjust for image edge
            crop.x = Math.floor(Math.max(0, Math.min(crop.x, img.w - crop.w)))
        }

        return crop
    },

    getRatioThumbCrop(target) {
        // expects w/h ratio.
        /*
            examples:
            3:2 target === 1.5
            1:1 target === 1
        */

        // assumes image has dims and a highlight
        if (! this.hasDims() || ! this.hasHighlight()) return

        // cache dims
        const img = {
            w: this.get('width'),
            h: this.get('height'),
        }

        const crop = { x: 0, w: 0, y: 0, h: 0 }

        const ratio = img.h / img.w

        if (ratio > (1 / target)) {
            // portrait, square, square-ish images
            crop.w = img.w
            crop.h = Math.floor(img.w * (1 / target))
            // get center of highlight from top (y + (h / 2))
            const top = this.get('highlight.y') + (this.get('highlight.h') / 2)
            // calculate strict y (t - (h / 2))
            crop.y = top - (crop.h / 2)
            // adjust for image edge
            crop.y = Math.floor(Math.max(0, Math.min(crop.y, img.h - crop.h)))
        } else {
            crop.h = img.h
            crop.w = Math.floor(img.h * target)
            // get center of highlight from left (x + (w / 2))
            const left = this.get('highlight.x') + (this.get('highlight.w') / 2)
            // calculate strict x (l - (w / 2))
            crop.x = left - (crop.w / 2)
            // adjust for image edge
            crop.x = Math.floor(Math.max(0, Math.min(crop.x, img.w - crop.w)))
        }

        return crop
    },

})

module.exports = SavedImage
